import HeaderComponent from "../../components/header/headerComponent";
import { useTranslation } from "react-i18next";
import BannerPage from "./BannerPage";

const BannerMainPage = () => {
  const { t } = useTranslation();
  return (
    <>
    <HeaderComponent pageTitle={t(`Banner Management`)} >
      <BannerPage  />
    </HeaderComponent>
    </>
  )
}

export default BannerMainPage